/**
 * Reown AppKit config: Connect with wallet (WalletConnect, injected) or email/social.
 * Must be imported once at app root (e.g. App.js) so createAppKit runs before any hooks.
 */
import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { defineChain } from "@reown/appkit/networks";
import { WaitForCallsStatusTimeoutError } from "viem";

// Block MetaMask popup on load: for 2s after app boot, eth_requestAccounts is answered with eth_accounts (no prompt)
if (typeof window !== "undefined" && window.ethereum) {
  const rawRequest = window.ethereum.request.bind(window.ethereum);
  window.__ORIGINAL_ETHEREUM_REQUEST__ = rawRequest;
  window.ethereum.request = async (args) => {
    if (args?.method === "eth_requestAccounts") {
      return rawRequest({ method: "eth_accounts" });
    }
    return rawRequest(args);
  };
  setTimeout(() => {
    window.ethereum.request = rawRequest;
  }, 2000);
}

// Set REACT_APP_REOWN_PROJECT_ID in your .env file (see .env.example).
// Get your Project ID from https://cloud.reown.com (Reown Dashboard).
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || "213b0f2ece4491ddded5b8b76d1ad8a0";

if ((!projectId || projectId === "213b0f2ece4491ddded5b8b76d1ad8a0") && process.env.NODE_ENV === "staging") {
  console.warn(
    "[Reown] REACT_APP_REOWN_PROJECT_ID is not set. Add it to your .env file and restart the dev server. Get your Project ID from https://cloud.reown.com"
  );
}

const bsc = defineChain({
  id: 56,
  caipNetworkId: "eip155:56",
  chainNamespace: "eip155",
  name: "BNB Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB",
  },
  rpcUrls: {
    default: { http: ["https://bsc-dataseed1.binance.org/"] },
  },
  blockExplorers: {
    default: { name: "BscScan", url: "https://bscscan.com" },
  },
});

const metadata = {
  name: "TCG.Zone",
  description: "Pokemon Marketplace",
  url: typeof window !== "undefined" ? window.location.origin : "https://tcg.zone",
  icons: ["https://avatars.githubusercontent.com/u/179229932"],
};

createAppKit({
  adapters: [new EthersAdapter()],
  networks: [bsc],
  projectId,
  metadata,
  features: {
    email: true,
    socials: ["google", "apple", "x", "github", "discord"],
    emailShowWallets: true,
    analytics: false,
    swaps: false,
    onramp: false,
  },
});
